function initSocialSharingScript(){

    console.log( 'initSocialSharingScript')
    let awSocialSharingloaded = false;

    function setupSocialSharing(){

        const elsIcons = document.querySelectorAll('.aw-social-share-icon');

        awSocialSharingloaded = true;
        console.log("%cSetting up Social Sharing Widget", "color: yellow; font-style: italic; background-color: blue;padding: 2px");
        
        let isRenderingInline = false;

        if( window.adw_social_share && adw_social_share.renderInline ){
            isRenderingInline = true;
        }
    
        // Current window width variable
    
        let defaultStateIsClosed;
    
        // Store URL and Title of the page from meta tags
    
        let dataTitle;
        let bitlyURL;
        let postID;

        const elArticle = document.querySelector('article');
    
        if( elArticle ){
            
            // Check for Title
            let articleTitle = elArticle?.getAttribute?.('data-title');
            if ( !articleTitle ){
                if( document.getElementsByTagName('title').length > 0 ){
                    articleTitle = document.getElementsByTagName('title')[0].innerText;
                }
            }
            dataTitle = articleTitle ? articleTitle : 'Breaking News in Advertising, Media and Technology';
    
            // Check Bitly Link
            function checkBitly(){
                bitlyURL = elArticle.getAttribute?.('data-bitlyurl');
                if( !bitlyURL ){
                    bitlyURL = window.location.href;
                }
            }
    
            checkBitly();
			
        }

        console.log( 'Bitly URL: ', bitlyURL );
    
        // Encoded
    
        const encodedUrl = encodeURIComponent(bitlyURL);
        const encodedTitle = encodeURIComponent(dataTitle);
        const encodedBody = encodeURIComponent('I thought you would be interested in this from Adweek.com...\n\n' + dataTitle + ':\n' + bitlyURL);
    
        // Share on Facebook
    
        document.querySelector( '#share-on-facebook' )?.addEventListener?.( 'click', function(e){
            e.preventDefault();
            createPopupWin(
                `https://www.facebook.com/sharer/sharer.php?u=${bitlyURL}`,
                'Share on Facebook', 700, 650
            );
        } );
    
    // Share on Twitter    
    
        document.querySelector('#share-on-twitter')?.addEventListener?.('click', function(e){
            e.preventDefault();
    
            const twitterUrlReq = 'https://twitter.com/intent/tweet?original_referer=' + encodedUrl + '&text=' + encodedTitle + '&url=' + encodedUrl + '&via=Adweek';
    
            // Example https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fdeveloper.twitter.com%2Fen%2Fdocs%2Ftwitter-for-websites%2Ftweet-button%2Foverview&ref_src=twsrc%5Etfw&text=Guides%20%E2%80%94%20Twitter%20Developers&tw_p=tweetbutton&url=https%3A%2F%2Fdeveloper.twitter.com%2Fen%2Fdocs%2Ftwitter-for-websites%2Ftweet-button%2Foverview.html
            createPopupWin(twitterUrlReq, 'Share on Twitter', 700, 650);
        });
        function createPopupWin(pageURL, pageTitle, popupWinWidth, popupWinHeight) { 
            const left = ( screen.width/2 - popupWinWidth/2) ; 
            const top = ( screen.height/2 - popupWinHeight/2) ; 
            const myWindow = window.open(
                pageURL,
                pageTitle,  
                'resizable=yes,width=' + popupWinWidth 
                + ', height=' + popupWinHeight + ', top=' 
                + top + ', left=' + left); 
        };
    
        // Share on LinkedIn
    
        document.querySelector('#share-on-linkedin')?.addEventListener?.( 'click', function(e){
            e.preventDefault();
        
            let linkedInUrlReq = 'https://www.linkedin.com/shareArticle';
            linkedInUrlReq += '?mini=true';
            linkedInUrlReq += '&url=' + encodedUrl;
            linkedInUrlReq += '&title=' + encodedTitle;
            linkedInUrlReq += '&source=Adweek';
    
            const pageTitle = 'Share on LinkedIn';
    
            createPopupWinForLinkedIn(linkedInUrlReq, pageTitle, 700, 650);
        });
        function createPopupWinForLinkedIn(pageURL, pageTitle, popupWinWidth, popupWinHeight) { 
            const left = ( screen.width/2 - popupWinWidth/2) ; 
            const top = ( screen.height/2 - popupWinHeight/2) ; 
            const linkedInWindow = window.open(
                pageURL,
                pageTitle,  
                'resizable=yes,width=' + popupWinWidth 
                + ', height=' + popupWinHeight + ', top=' 
                + top + ', left=' + left); 
        };
    
        const elMessenger = document.querySelector('#share-on-messenger');
        // Share on Facebook Messenger
        if ( !awIsMobile() ) {
            elMessenger?.remove?.();
        }
        
        elMessenger?.addEventListener?.('click', function(e){
            e.preventDefault();
            window.open('fb-messenger://share?link=' + encodedUrl + '&app_id=' + encodeURIComponent(163666967610998));
        })
    
        // Share via email
    
        const elShareViaEmail = document.querySelector('#share-via-email');
        if( elShareViaEmail ){
            elShareViaEmail.href = `mailto:?subject=${encodedTitle}&body=${encodedBody}&utm_source=email&utm_medium=awshare`;
        }
    
        // Share with a printer
    
        postID = window.aw.post_id;
        let encodedAuthors;

        const elContributorByline = document.getElementById('contributor-byline');
    
        if( elContributorByline ){
            let authors = elContributorByline.getElementsByTagName('a');
            
            authors = [...authors];
    
            authors = authors.map( (author) => {
                return author.innerText;
            } );
            
            authors = authors.toString();
            authors = authors.replace(',', ', ');
            encodedAuthors = encodeURIComponent( authors );
        }
    
        // hide print icon if page is not an article
        const pfPrintIcon = document.querySelector( '#print-friendly' );
        
        if( pfPrintIcon ){
            if ( window.awLoggedIn ){

                const elBody = document.querySelector('body');
    
                if ( postID && !elBody.classList?.contains?.('page-template')
                && !elBody.classList?.contains?.('sponsored_post-template-page-shorthand')
                && !elBody.classList?.contains?.('single-partner_info') 
                && !elBody.classList?.contains?.('single-expert_info')
                && !elBody.classList?.contains?.('single-company-details') 
                && !elBody.classList?.contains?.('single-adw_photo_gallery')
                && !elBody.classList?.contains?.('single-aw_learning')) {
                    if ( window.awGetUserType() === 'S' && window.awGetUserCurrentTypePaid() ){
                        // if logged in
                        if( postID && elBody.classList?.contains?.('single') ){
                            pfPrintIcon.setAttribute( 'href', `${window.location.origin}/printer-friendly/?post_id=${postID}` );
                        }
                    } else if (window.awGetUserType() === 'R'){
                        // if logged in but not subscribed
                        pfPrintIcon.remove();
                    }
                    
                } else {
                    pfPrintIcon.remove();
                }
                
            } else {
                
                pfPrintIcon.remove();
            }
        }

        if( isRenderingInline ) return;
    
        // insert the widget in the right place after document is ready
        if(window.outerWidth >= 700){
            defaultStateIsClosed = false;
    
        } else {
            defaultStateIsClosed = true;
        }
    
        


        const elOpenIcon = document.querySelector( '#share-toggle-open-icon' );

        const elToggleIconImg = document.querySelector( '#share-toggle-open-icon img' );

        if( elOpenIcon ){

            if(anime && elsIcons?.length){
    
                const animeTimeline = anime.timeline({
                    duration: 200,
                    easing: 'easeOutSine',
                    autoplay: false,
                    delay: 100,
                    direction: defaultStateIsClosed ? 'normal' : 'reverse',
                    origin: 'bottom center',
                })
    
                animeTimeline.add({
                    targets: elsIcons,
                    opacity: [0,1],
                    translateY: ['10px', '0px'],
                    delay: anime.stagger(30, {
                        direction: 'reverse',
                        easing: 'easeOutSine',
                    }),
                    duration: 300,
                    easing: 'easeOutSine',
                    change: () => {
                        if( animeTimeline.direction === 'normal' ){
                            anime.set(elsIcons, {
                                display: 'block'
                            });
                            elToggleIconImg.setAttribute('src', window.location.origin + '/wp-content/plugins/aw-social-share-widget/images/close.svg');
                        } else {
                            elToggleIconImg.setAttribute('src', window.location.origin + '/wp-content/plugins/aw-social-share-widget/images/share.svg');
                        }
                    },
                    changeBegin: () => {
                        animeTimeline.direction === 'normal' && anime.set(elsIcons, {
                            display: 'block'
                        });
                    },
                    changeComplete: () => {
                        animeTimeline.direction === 'reverse' && anime.set(elsIcons, {
                            display: 'none'
                        });
                    },
                })
                
                anime.set(elOpenIcon, {
                    order: 1
                });
            
                if ( awIsMobile() || defaultStateIsClosed ){
                    elsIcons.forEach( (el) => el.style.display = 'none' );
                    elOpenIcon.classList.add('social-inactive');
                    elOpenIcon.classList.remove('social-active');
    
                    elToggleIconImg.setAttribute('src', window.location.origin + '/wp-content/plugins/aw-social-share-widget/images/share.svg');
                                        
                    anime({
                        targets: elOpenIcon,
                        opacity: [0,1],
                        duration: 300,
                        delay: 2000
                    });
                } else {
    
                    if( elsIcons && elsIcons.length > 0 && elOpenIcon ){
                        anime.set(elsIcons, {
                            translateY: '0px',
                            display: 'block'
                        });
            
                        anime({
                            targets: [elsIcons, elOpenIcon],
                            opacity: [0,1],
                            duration: 300,
                            delay: 2000,
                            easing: 'easeOutSine'
                        });
                    }
                }
    
                let playingForTheFirstTime = true;
        
                function toggleSocialShare() {
    
                    if( !playingForTheFirstTime ){
                        animeTimeline.reverse();
                    } else {
                        playingForTheFirstTime = false;
                    }
    
                    animeTimeline.play();
                    if ( elOpenIcon.classList.contains('social-inactive') ){
                        elOpenIcon.classList.add('social-active');
                        elOpenIcon.classList.remove('social-inactive');
                    } else if ( elOpenIcon.classList.contains('social-active') ){
                        elOpenIcon.classList.add('social-inactive');
                        elOpenIcon.classList.remove('social-active');
                    }
    
                }
        
                elOpenIcon.addEventListener( 'click', function(e) {
        
                    toggleSocialShare();
                    
                } );
            }
    
        } else {
    
            elOpenIcon.style.display = 'none';
            elsIcons.forEach( (el) => el.style.display = 'block' );
    
        }

        console.log( 'test social sharing' );
    
    }

    const canLoadSocialSharingScript = () => {
        const elsIcons = document.querySelectorAll('.aw-social-share-icon');
        return elsIcons.length !== 0;
    }

    window.addEventListener( 'DOMContentLoaded', function(){

        if( !canLoadSocialSharingScript() ) return;
     
        // Intersection Observer API for actions on scroll
        // The code below is intended to delay the execution of code by attaching it to intersection event
        const elShareIcon = document.querySelector('#aw-social-share-id');
        const postTypeToUseIntObs = ['post', 'adw_resource' ];

        if (
            'IntersectionObserver' in window &&
            document.querySelector('.entry-content') &&
            ( adw && adw.post && postTypeToUseIntObs.includes( adw.post.post_type ) )
        ) {

            // IntersectionObserver Supported
            let intObsOptions = {
                    root: null,
                    rootMargin: '0px',
                    threshold: [0.1, 0.9]
                };
        
            let observerForSocialShare = new IntersectionObserver(onIntObsChange, intObsOptions);
            const intObsTarget = document.querySelector('.entry-content');
            observerForSocialShare.observe( intObsTarget );

            function onIntObsChange(changes) {

                !awSocialSharingloaded && changes[0] && changes[0].isIntersecting && setupSocialSharing();

                changes.forEach(entry => {

                    if ( entry.intersectionRatio > 0 && elShareIcon?.style?.display === 'none' ) {

                        elShareIcon.style.display = 'block';
                        if( typeof anime !== 'undefined' ){
                            elShareIcon.style.opacity = '0';
                            anime({
                                targets: elShareIcon,
                                opacity: [0,1],
                                duration: 800,
                                easing: 'easeOutSine'
                            });
                        }
                        
                    } 
                })
            }
        
        } else {
            // IntersectionObserver NOT Supported
            setupSocialSharing();
            elShareIcon.style.display = 'block';
        }
   
    });
}

initSocialSharingScript();